const BRAND_TEXT = '#123F43';
const BRAND_ACCENT = '#D99A33';
const BRAND_SURFACE = '#F2EEE7';
const BRAND_SURFACE_SOFT = '#FBF8F2';
const BRAND_BORDER = '#DDD4C8';
const BRAND_MUTED = '#64716F';
const BRAND_SIDEBAR_ACTIVE = 'rgba(242, 238, 231, 0.12)';
const BRAND_CARD = '#FFFDF9';
const BRAND_TEXT_SOFT = 'rgba(18, 63, 67, 0.08)';
const BRAND_TEXT_SOFT_BORDER = 'rgba(18, 63, 67, 0.18)';
const BRAND_ACCENT_SOFT = '#F6E7C9';
const BRAND_ACCENT_TEXT = '#8A611E';
const BRAND_SUCCESS_SOFT = '#E7F2EC';
const BRAND_SUCCESS_TEXT = '#25624D';
const BRAND_SUCCESS_BORDER = '#BDD4C7';
const BRAND_DANGER_SOFT = '#FDEDEC';
const BRAND_DANGER_TEXT = '#A63B32';
const BRAND_DANGER_BORDER = '#E7B9B4';
const MESSAGE_INTERNAL = '#2563EB';
const MESSAGE_INTERNAL_SOFT = '#E8F0FF';
const MESSAGE_INTERNAL_TEXT = '#1E40AF';
const MESSAGE_INTERNAL_RING = 'rgba(37, 99, 235, 0.18)';

export const techDashboardStyles = {
    container: {
      display: 'flex',
      width: '100%',
      height: '100%',
      backgroundColor: BRAND_SURFACE,
      fontFamily: 'Inter, system-ui, sans-serif'
    },
    sidebar: {
      width: '250px',
      backgroundColor: BRAND_TEXT,
      color: 'white',
      padding: '0',
      display: 'flex',
      flexDirection: 'column' as const,
      position: 'relative' as const
    },
    logo: {
      padding: '1.1rem 1.35rem',
      marginBottom: '1.25rem',
      backgroundColor: BRAND_SURFACE,
      borderBottom: `1px solid ${BRAND_BORDER}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    logoImage: {
      display: 'block',
      width: '100%',
      maxWidth: '168px',
      height: 'auto'
    },
    nav: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      flex: 1,
      overflowY: 'auto' as const
    },
    navItem: {
      padding: '1rem 1.5rem',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      fontSize: '1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    navItemActive: {
      backgroundColor: BRAND_SIDEBAR_ACTIVE
    },
    navBadge: {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      borderRadius: '999px',
      padding: '0.1rem 0.55rem',
      fontSize: '0.75rem',
      fontWeight: 700
    },
    navBadgeStack: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.35rem'
    },
    navBadgeInternal: {
      backgroundColor: MESSAGE_INTERNAL,
      color: '#ffffff',
      borderRadius: '999px',
      padding: '0.1rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: 700,
      minWidth: '1.6rem',
      textAlign: 'center' as const
    },
    navBadgeExternal: {
      backgroundColor: BRAND_ACCENT,
      color: '#ffffff',
      borderRadius: '999px',
      padding: '0.1rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: 700,
      minWidth: '1.6rem',
      textAlign: 'center' as const
    },
    navNotification: {
      backgroundColor: BRAND_ACCENT,
      color: 'white',
      borderRadius: '9999px',
      padding: '0.25rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: 'bold'
    },
    userSection: {
      marginTop: 'auto',
      padding: '1.5rem',
      borderTop: '1px solid rgba(242, 238, 231, 0.16)'
    },
    sidebarFooter: {
      padding: '1rem 1.5rem',
      borderTop: '1px solid rgba(242, 238, 231, 0.16)'
    },
    sidebarActionButton: {
      width: '100%',
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT,
      borderRadius: '999px',
      border: `1px solid ${BRAND_BORDER}`,
      padding: '0.6rem 1rem',
      fontWeight: 600,
      cursor: 'pointer'
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column' as const,
      minWidth: 0,
      minHeight: 0
    },
    header: {
      backgroundColor: BRAND_SURFACE,
      padding: '1rem 2rem',
      borderBottom: `1px solid ${BRAND_BORDER}`
    },
    headerTitleGroup: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.75rem',
      flex: 1,
      minWidth: 0
    },
    controlStack: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.75rem',
      width: '100%'
    },
    pageTitle: {
      fontSize: '1.6rem',
      fontWeight: 600,
      margin: 0,
      color: BRAND_TEXT
    },
    pageSubtitle: {
      fontSize: '0.95rem',
      color: BRAND_MUTED
    },
    casesHeaderPanel: {
      display: 'grid',
      gap: '0.9rem'
    },
    casesHeaderTop: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    casesHeaderActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.6rem',
      flexWrap: 'wrap' as const,
      justifyContent: 'flex-end'
    },
    casesTitleWrap: {
      display: 'grid',
      gap: '0.3rem'
    },
    casesTopPanelCollapsedBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem',
      padding: '0.75rem 0.9rem',
      borderRadius: '0.85rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      flexWrap: 'wrap' as const
    },
    casesTopPanelCollapsedText: {
      fontSize: '0.84rem',
      color: BRAND_MUTED,
      lineHeight: 1.45
    },
    messagesLayout: {
      display: 'grid',
      gap: '1.5rem',
      padding: '1.5rem 2rem'
    },
    messagesSection: {
      backgroundColor: BRAND_SURFACE_SOFT,
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.25rem',
      display: 'grid',
      gap: '1rem'
    },
    modalForm: {
      display: 'grid',
      gap: '1rem'
    },
    modalField: {
      display: 'grid',
      gap: '0.35rem'
    },
    modalLabel: {
      fontSize: '0.85rem',
      fontWeight: 600,
      color: '#374151'
    },
    modalInput: {
      width: '100%',
      padding: '0.6rem 0.75rem',
      borderRadius: '0.5rem',
      border: '1px solid #d1d5db',
      fontSize: '0.9rem'
    },
    modalSelect: {
      width: '100%',
      padding: '0.6rem 0.75rem',
      borderRadius: '0.5rem',
      border: '1px solid #d1d5db',
      fontSize: '0.9rem',
      backgroundColor: '#ffffff'
    },
    modalTextarea: {
      width: '100%',
      padding: '0.6rem 0.75rem',
      borderRadius: '0.5rem',
      border: '1px solid #d1d5db',
      fontSize: '0.9rem',
      resize: 'vertical' as const
    },
    modalRow: {
      display: 'grid',
      gap: '0.75rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))'
    },
    modalHelper: {
      fontSize: '0.8rem',
      color: '#6b7280'
    },
    internalJobTabs: {
      display: 'inline-flex',
      borderRadius: '999px',
      padding: '0.2rem',
      backgroundColor: BRAND_CARD,
      border: `1px solid ${BRAND_BORDER}`,
      marginBottom: '1rem',
      gap: '0.25rem',
      boxShadow: '0 1px 4px rgba(18, 63, 67, 0.08)'
    },
    internalJobTabButton: {
      border: '1px solid transparent',
      backgroundColor: 'transparent',
      color: BRAND_TEXT,
      borderRadius: '999px',
      padding: '0.45rem 1rem',
      fontSize: '0.82rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    internalJobTabButtonActive: {
      backgroundColor: BRAND_TEXT,
      borderColor: BRAND_TEXT,
      color: '#ffffff'
    },
    uploadDropzone: {
      border: '1px dashed #cbd5f5',
      borderRadius: '0.75rem',
      padding: '1rem',
      backgroundColor: '#f8fafc',
      textAlign: 'center' as const,
      cursor: 'pointer'
    },
    uploadDropzoneActive: {
      borderColor: '#2563eb',
      backgroundColor: '#eff6ff'
    },
    uploadList: {
      display: 'grid',
      gap: '0.5rem',
      marginTop: '0.75rem'
    },
    uploadItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.5rem 0.75rem',
      borderRadius: '0.5rem',
      backgroundColor: '#f3f4f6',
      fontSize: '0.85rem'
    },
    uploadRemove: {
      border: 'none',
      backgroundColor: 'transparent',
      color: '#b91c1c',
      cursor: 'pointer',
      fontWeight: 600
    },
    modalActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.75rem',
      justifyContent: 'flex-end'
    },
    metricsPanel: {
      backgroundColor: BRAND_SURFACE_SOFT,
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.25rem',
      marginBottom: '1.5rem'
    },
    metricsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '1rem'
    },
    metricsCard: {
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      padding: '0.9rem 1rem',
      backgroundColor: '#fffdf9',
      display: 'grid',
      gap: '0.35rem'
    },
    metricsLabel: {
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    metricsValue: {
      fontSize: '1.4rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    metricsTable: {
      width: '100%',
      borderCollapse: 'collapse' as const
    },
    metricsTh: {
      textAlign: 'left' as const,
      fontSize: '0.8rem',
      fontWeight: 700,
      color: '#6b7280',
      borderBottom: '1px solid #e5e7eb',
      paddingBottom: '0.5rem'
    },
    metricsTd: {
      padding: '0.5rem 0',
      borderBottom: '1px solid #f3f4f6',
      fontSize: '0.9rem',
      color: '#111827'
    },
    metricsControls: {
      display: 'grid',
      gap: '0.75rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      marginBottom: '1rem'
    },
    metricsWorkspaceSection: {
      display: 'grid',
      gap: '0.5rem',
      marginBottom: '1rem'
    },
    metricsWorkspaceLabel: {
      margin: 0,
      fontSize: '0.76rem',
      letterSpacing: '0.08em',
      textTransform: 'uppercase' as const,
      fontWeight: 700,
      color: '#475569'
    },
    metricsWorkspaceTabs: {
      display: 'grid',
      gap: '0.6rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(155px, 1fr))'
    },
    metricsWorkspaceTab: {
      border: '2px solid #cbd5e1',
      borderRadius: '0.8rem',
      backgroundColor: '#f8fafc',
      color: '#0f172a',
      fontWeight: 700,
      fontSize: '0.93rem',
      padding: '0.7rem 0.85rem',
      cursor: 'pointer',
      whiteSpace: 'nowrap' as const,
      boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)'
    },
    metricsWorkspaceTabActive: {
      backgroundColor: '#1d4ed8',
      borderColor: '#1d4ed8',
      color: '#ffffff',
      boxShadow: '0 0 0 2px rgba(29, 78, 216, 0.2)'
    },
    insightsHeaderActions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    insightsWorkspaceTabs: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      flexWrap: 'wrap' as const,
      marginBottom: '1rem'
    },
    insightsWorkspaceTab: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      fontWeight: 700,
      fontSize: '0.92rem',
      padding: '0.7rem 1rem',
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.08)'
    },
    insightsWorkspaceTabActive: {
      backgroundColor: BRAND_TEXT,
      borderColor: BRAND_TEXT,
      color: '#ffffff',
      boxShadow: '0 8px 18px rgba(18, 63, 67, 0.14)'
    },
    insightsFilterBar: {
      backgroundColor: BRAND_SURFACE_SOFT,
      borderRadius: '0.9rem',
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
      padding: '1rem 1.1rem',
      marginBottom: '1.25rem'
    },
    insightsFilterGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
      gap: '0.85rem',
      alignItems: 'center'
    },
    insightsFilterInput: {
      width: '100%',
      minWidth: '150px',
      minHeight: '46px',
      padding: '0.72rem 0.85rem',
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      color: BRAND_TEXT,
      backgroundColor: '#fffdf9',
      fontSize: '0.92rem',
      boxShadow: 'inset 0 1px 2px rgba(18, 63, 67, 0.04)',
      boxSizing: 'border-box' as const
    },
    insightsSignalsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '0.9rem',
      marginBottom: '1.1rem'
    },
    insightsSignalCard: {
      borderRadius: '0.9rem',
      border: `1px solid ${BRAND_BORDER}`,
      padding: '0.95rem 1rem',
      display: 'grid',
      gap: '0.3rem',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)'
    },
    insightsSignalDanger: {
      backgroundColor: BRAND_DANGER_SOFT,
      borderColor: BRAND_DANGER_BORDER,
      color: BRAND_DANGER_TEXT
    },
    insightsSignalWarning: {
      backgroundColor: BRAND_ACCENT_SOFT,
      borderColor: '#E7C48E',
      color: BRAND_ACCENT_TEXT
    },
    insightsSignalInfo: {
      backgroundColor: BRAND_SUCCESS_SOFT,
      borderColor: BRAND_SUCCESS_BORDER,
      color: BRAND_SUCCESS_TEXT
    },
    insightsSignalTitle: {
      fontSize: '0.92rem',
      fontWeight: 700
    },
    insightsSignalDetail: {
      fontSize: '0.84rem',
      lineHeight: 1.45
    },
    insightsKpiGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
      gap: '0.9rem',
      marginBottom: '1.25rem'
    },
    insightsKpiCard: {
      borderRadius: '0.9rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
      padding: '1rem 1.05rem',
      display: 'grid',
      gap: '0.35rem',
      minHeight: '108px'
    },
    insightsKpiLabel: {
      fontSize: '0.82rem',
      color: BRAND_MUTED,
      fontWeight: 600
    },
    insightsKpiValue: {
      fontSize: '1.8rem',
      lineHeight: 1.05,
      fontWeight: 700,
      color: BRAND_TEXT
    },
    insightsKpiMeta: {
      fontSize: '0.82rem',
      color: BRAND_MUTED,
      lineHeight: 1.45
    },
    insightsWidgetGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '1rem',
      marginBottom: '1.5rem'
    },
    insightsCompactWidgetGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      gap: '1rem',
      marginBottom: '1.5rem'
    },
    insightsWidget: {
      gridColumn: 'span 1',
      borderRadius: '1rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
      padding: '1.1rem 1.15rem',
      display: 'grid',
      gap: '0.95rem',
      alignContent: 'start'
    },
    insightsWidgetWide: {
      gridColumn: '1 / -1'
    },
    inventoryInsightsGrid: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 2fr) minmax(360px, 1fr)',
      gap: '1rem',
      alignItems: 'start',
      marginBottom: '1.5rem'
    },
    inventoryInsightsColumn: {
      display: 'grid',
      gap: '1rem',
      alignContent: 'start'
    },
    inventoryInlineGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: '1rem',
      alignItems: 'start'
    },
    inventoryPanelFull: {
      gridColumn: '1 / -1'
    },
    teamInsightsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
      gap: '1rem',
      alignItems: 'start',
      marginBottom: '1.5rem'
    },
    teamInsightsWideGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(520px, 1fr))',
      gap: '1rem',
      alignItems: 'start',
      marginBottom: '1.5rem'
    },
    teamPanelFull: {
      gridColumn: '1 / -1'
    },
    inventoryCountGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: '1rem',
      alignItems: 'start'
    },
    insightsWidgetHeader: {
      display: 'grid',
      gap: '0.2rem'
    },
    insightsWidgetTitle: {
      fontSize: '1rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    insightsWidgetMeta: {
      fontSize: '0.82rem',
      color: BRAND_MUTED,
      lineHeight: 1.45
    },
    insightsEmptyState: {
      fontSize: '0.88rem',
      color: BRAND_MUTED,
      padding: '0.2rem 0'
    },
    insightsList: {
      display: 'grid',
      gap: '0.65rem'
    },
    insightsListRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      borderRadius: '0.85rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.8rem 0.9rem'
    },
    insightsListMain: {
      display: 'grid',
      gap: '0.18rem',
      flex: 1,
      minWidth: 0
    },
    insightsListTitle: {
      fontSize: '0.92rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    insightsListMeta: {
      fontSize: '0.82rem',
      color: BRAND_MUTED,
      lineHeight: 1.4
    },
    insightsListValue: {
      fontSize: '1rem',
      fontWeight: 700,
      color: BRAND_TEXT,
      whiteSpace: 'nowrap' as const
    },
    insightsTableScroll: {
      width: '100%',
      overflowX: 'auto' as const,
      minWidth: 0
    },
    insightsTableNumber: {
      textAlign: 'right' as const,
      whiteSpace: 'nowrap' as const
    },
    inventoryIssueList: {
      display: 'grid',
      gap: '0.7rem'
    },
    inventoryIssueRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) auto',
      alignItems: 'center',
      gap: '0.9rem',
      borderRadius: '0.9rem',
      border: `1px solid ${BRAND_DANGER_BORDER}`,
      backgroundColor: BRAND_DANGER_SOFT,
      padding: '0.85rem 0.95rem'
    },
    inventoryIssueValue: {
      color: BRAND_DANGER_TEXT,
      fontWeight: 800,
      whiteSpace: 'nowrap' as const
    },
    insightsBarTrack: {
      width: '100%',
      height: '0.45rem',
      borderRadius: '999px',
      backgroundColor: '#ECE5D9',
      overflow: 'hidden'
    },
    insightsBarFill: {
      height: '100%',
      borderRadius: '999px',
      backgroundColor: BRAND_TEXT
    },
    insightsBucketGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
      gap: '0.75rem'
    },
    insightsBucketCard: {
      borderRadius: '0.9rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.95rem 0.85rem',
      display: 'grid',
      gap: '0.2rem',
      justifyItems: 'center',
      textAlign: 'center' as const
    },
    insightsBucketValue: {
      fontSize: '1.4rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    insightsBucketLabel: {
      fontSize: '0.82rem',
      color: BRAND_MUTED
    },
    insightsMiniGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
      gap: '0.75rem'
    },
    insightsMiniCard: {
      borderRadius: '0.85rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.9rem 0.8rem',
      display: 'grid',
      gap: '0.2rem'
    },
    insightsMiniValue: {
      fontSize: '1.35rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    insightsMiniLabel: {
      fontSize: '0.8rem',
      color: BRAND_MUTED,
      lineHeight: 1.4
    },
    metricsSubtext: {
      color: '#64748b',
      fontSize: '0.85rem',
      marginBottom: '0.75rem'
    },
    metricsWidgetRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      padding: '0.5rem 0',
      borderBottom: '1px solid #f3f4f6'
    },
    metricsWidgetActions: {
      display: 'flex',
      gap: '0.4rem'
    },
    metricsSmallButton: {
      border: '1px solid #d1d5db',
      backgroundColor: '#f9fafb',
      borderRadius: '0.4rem',
      padding: '0.2rem 0.5rem',
      fontSize: '0.75rem',
      cursor: 'pointer'
    },
    metricsIncludeModalContent: {
      maxWidth: '760px',
      borderRadius: '1rem',
      padding: '1.5rem',
      boxShadow: '0 24px 54px rgba(15, 23, 42, 0.18)'
    },
    metricsIncludeModalHeader: {
      display: 'grid',
      gap: '0.35rem'
    },
    metricsIncludeModalIntro: {
      color: BRAND_MUTED,
      fontSize: '0.92rem',
      lineHeight: 1.5,
      maxWidth: '46rem'
    },
    metricsIncludeList: {
      display: 'grid',
      gap: '0.85rem'
    },
    metricsIncludeRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      padding: '0.95rem 1rem',
      borderRadius: '0.95rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT
    },
    metricsIncludeMain: {
      display: 'grid',
      gap: '0.25rem',
      minWidth: 0,
      flex: 1
    },
    metricsIncludeLabel: {
      color: BRAND_TEXT,
      fontWeight: 700,
      fontSize: '0.98rem'
    },
    metricsIncludeDescription: {
      color: BRAND_MUTED,
      fontSize: '0.84rem',
      lineHeight: 1.45
    },
    metricsIncludeToggle: {
      borderRadius: '999px',
      padding: '0.45rem 0.9rem',
      fontSize: '0.8rem',
      fontWeight: 700,
      cursor: 'pointer',
      minWidth: '100px',
      transition: 'background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease'
    },
    metricsIncludeToggleActive: {
      border: `1px solid ${BRAND_TEXT}`,
      backgroundColor: BRAND_TEXT,
      color: '#ffffff'
    },
    metricsIncludeToggleInactive: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_MUTED
    },
    messagesSectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      alignItems: 'flex-start',
      flexWrap: 'wrap' as const
    },
    messagesNewButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT,
      borderRadius: '0.6rem',
      padding: '0.45rem 0.9rem',
      fontWeight: 600,
      cursor: 'pointer',
      whiteSpace: 'nowrap' as const
    },
    messagesChannelTabs: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.6rem',
      flexWrap: 'wrap' as const
    },
    messagesChannelTab: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '999px',
      padding: '0.4rem 0.9rem',
      fontWeight: 600,
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.45rem',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT
    },
    messagesChannelTabInternal: {
      borderColor: MESSAGE_INTERNAL,
      backgroundColor: MESSAGE_INTERNAL_SOFT,
      color: MESSAGE_INTERNAL_TEXT
    },
    messagesChannelTabExternal: {
      borderColor: BRAND_ACCENT,
      backgroundColor: '#FCF6EA',
      color: BRAND_ACCENT_TEXT
    },
    messagesChannelTabActiveInternal: {
      boxShadow: `0 0 0 2px ${MESSAGE_INTERNAL_RING}`
    },
    messagesChannelTabActiveExternal: {
      boxShadow: '0 0 0 2px rgba(217, 154, 51, 0.22)'
    },
    messagesChannelTabCountInternal: {
      backgroundColor: MESSAGE_INTERNAL,
      color: '#ffffff',
      borderRadius: '999px',
      padding: '0.05rem 0.45rem',
      minWidth: '1.45rem',
      textAlign: 'center' as const,
      fontSize: '0.75rem',
      fontWeight: 700
    },
    messagesChannelTabCountExternal: {
      backgroundColor: BRAND_ACCENT,
      color: '#ffffff',
      borderRadius: '999px',
      padding: '0.05rem 0.45rem',
      minWidth: '1.45rem',
      textAlign: 'center' as const,
      fontSize: '0.75rem',
      fontWeight: 700
    },
    messagesFilterRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '0.75rem',
      alignItems: 'center',
      padding: '0.85rem',
      borderRadius: '0.7rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#ffffff'
    },
    messagesFilterToggle: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    messagesFilterToggleInput: {
      width: '16px',
      height: '16px'
    },
    messagesListScroll: {
      maxHeight: '60vh',
      overflowY: 'auto' as const,
      paddingRight: '0.25rem'
    },
    messagesLoadMore: {
      marginTop: '0.5rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '0.6rem',
      padding: '0.5rem 1rem',
      fontWeight: 600,
      cursor: 'pointer',
      justifySelf: 'start'
    },
    messagesItem: {
      textAlign: 'left' as const,
      padding: '0.75rem',
      borderRadius: '0.65rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#ffffff',
      display: 'grid',
      gap: '0.4rem',
      cursor: 'pointer',
      width: '100%',
      fontFamily: 'inherit',
      appearance: 'none' as const
    },
    messagesItemActiveExternal: {
      borderColor: 'rgba(18, 63, 67, 0.28)',
      backgroundColor: BRAND_SURFACE_SOFT,
      boxShadow: '0 0 0 1px rgba(18, 63, 67, 0.08)'
    },
    messagesItemActiveInternal: {
      borderColor: 'rgba(18, 63, 67, 0.28)',
      backgroundColor: BRAND_SURFACE_SOFT,
      boxShadow: '0 0 0 1px rgba(18, 63, 67, 0.08)'
    },
    messagesItemHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    messagesItemHeaderLeft: {
      display: 'grid',
      gap: '0.45rem'
    },
    messagesItemBadgeRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.45rem',
      flexWrap: 'wrap' as const
    },
    messagesSenderBadge: {
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.02em',
      textTransform: 'uppercase' as const,
      padding: '0.2rem 0.6rem',
      borderRadius: '999px',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT
    },
    messagesSenderBadgeSupport: {
      color: '#1d4ed8',
      backgroundColor: '#eff6ff',
      border: '1px solid #bfdbfe'
    },
    messagesSenderBadgeInternal: {
      color: MESSAGE_INTERNAL_TEXT,
      backgroundColor: MESSAGE_INTERNAL_SOFT,
      border: `1px solid ${MESSAGE_INTERNAL_RING}`
    },
    messagesFocusBadge: {
      fontSize: '0.78rem',
      fontWeight: 600,
      padding: '0.2rem 0.6rem',
      borderRadius: '999px',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      color: BRAND_MUTED
    },
    messagesStateBadge: {
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.02em',
      textTransform: 'uppercase' as const,
      padding: '0.2rem 0.6rem',
      borderRadius: '999px',
      border: '1px solid #d6d3d1',
      backgroundColor: '#f5f5f4',
      color: '#57534e'
    },
    messagesItemTitle: {
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.35,
      color: BRAND_TEXT
    },
    messagesUnreadBadge: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      fontSize: '0.7rem',
      padding: '0.15rem 0.5rem',
      borderRadius: '999px',
      fontWeight: 700,
      border: '1px solid #bfdbfe'
    },
    messagesUnreadBadgeInternal: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      border: '1px solid #bfdbfe'
    },
    messagesUnreadBadgeExternal: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      border: '1px solid #bfdbfe'
    },
    messagesItemBody: {
      color: BRAND_TEXT,
      lineHeight: 1.5,
      fontSize: '0.95rem',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical' as const,
      overflow: 'hidden',
      wordBreak: 'break-word' as const,
      overflowWrap: 'anywhere' as const
    },
    messagesItemMeta: {
      fontSize: '0.8rem',
      color: BRAND_MUTED
    },
    messagesItemMetaRow: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '0.75rem',
      flexWrap: 'wrap' as const,
      alignItems: 'center'
    },
    messagesItemMetaGroup: {
      display: 'flex',
      gap: '0.5rem',
      flexWrap: 'wrap' as const,
      alignItems: 'center'
    },
    messagesItemMetaTag: {
      fontSize: '0.78rem',
      color: BRAND_MUTED,
      borderRadius: '999px',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#ffffff',
      padding: '0.18rem 0.55rem'
    },
    messagesComposer: {
      backgroundColor: '#ffffff',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.5rem',
      display: 'grid',
      gap: '0.75rem'
    },
    messagesDetailCard: {
      backgroundColor: '#ffffff',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.5rem',
      display: 'grid',
      gap: '0.75rem'
    },
    messagesPanel: {
      backgroundColor: '#ffffff',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.25rem',
      display: 'grid',
      gap: '1rem'
    },
    messagesPanelHeader: {
      display: 'grid',
      gap: '0.35rem'
    },
    messagesPanelTitle: {
      fontSize: '1.1rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    messagesPanelSubtitle: {
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    messagesFilters: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '0.75rem'
    },
    messagesToggle: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '0.85rem',
      color: '#374151'
    },
    messagesToggleInput: {
      width: '16px',
      height: '16px'
    },
    messagesList: {
      display: 'grid',
      gap: '0.75rem'
    },
    messagesListItem: {
      textAlign: 'left' as const,
      padding: '0.85rem',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb',
      display: 'grid',
      gap: '0.4rem',
      cursor: 'pointer'
    },
    messagesListItemActive: {
      borderColor: '#2563eb',
      backgroundColor: '#eff6ff'
    },
    messagesListHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      fontWeight: 600,
      color: '#111827'
    },
    messagesListMeta: {
      fontSize: '0.75rem',
      color: '#6b7280'
    },
    messagesListFocus: {
      fontSize: '0.8rem',
      color: '#2563eb'
    },
    messagesListBody: {
      fontSize: '0.9rem',
      color: '#374151'
    },
    messagesDetailPanel: {
      backgroundColor: '#ffffff',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
      padding: '1.5rem',
      display: 'grid',
      gap: '1rem',
      alignContent: 'start'
    },
    messagesComposePanel: {
      border: '1px solid #e5e7eb',
      borderRadius: '0.75rem',
      padding: '1rem',
      backgroundColor: '#f8fafc',
      display: 'grid',
      gap: '0.75rem'
    },
    messagesComposeTitle: {
      fontSize: '1rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    messagesComposeSubtitle: {
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    messagesField: {
      display: 'grid',
      gap: '0.5rem'
    },
    messagesLabel: {
      fontSize: '0.85rem',
      fontWeight: 600,
      color: BRAND_TEXT
    },
    messagesAttachmentRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem'
    },
    messagesAttachmentList: {
      display: 'grid',
      gap: '0.5rem'
    },
    messagesAttachmentRemove: {
      border: 'none',
      backgroundColor: 'transparent',
      color: BRAND_DANGER_TEXT,
      fontWeight: 600,
      cursor: 'pointer'
    },
    messagesComposeGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '0.75rem'
    },
    messagesComposeInput: {
      width: '100%',
      boxSizing: 'border-box' as const,
      minHeight: '160px',
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      padding: '0.75rem',
      fontFamily: 'inherit',
      fontSize: '0.9rem',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      resize: 'vertical' as const
    },
    messagesComposeActions: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    messagesDetailHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem'
    },
    messagesDetailTitle: {
      fontSize: '1.1rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    messagesDetailMeta: {
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    messagesDetailTimestamp: {
      fontSize: '0.8rem',
      color: BRAND_MUTED
    },
    messagesDetailBody: {
      fontSize: '0.95rem',
      color: BRAND_TEXT,
      lineHeight: 1.5,
      whiteSpace: 'pre-wrap' as const,
      wordBreak: 'break-word' as const,
      overflowWrap: 'anywhere' as const
    },
    messagesDetailAttachments: {
      display: 'grid',
      gap: '0.5rem'
    },
    messagesAttachmentItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.5rem 0.75rem',
      borderRadius: '0.6rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      border: `1px solid ${BRAND_BORDER}`,
      fontSize: '0.85rem',
      color: BRAND_TEXT
    },
    messagesReplyPanel: {
      borderTop: `1px solid ${BRAND_BORDER}`,
      paddingTop: '1rem',
      display: 'grid',
      gap: '0.75rem'
    },
    messagesReplyTitle: {
      fontSize: '0.85rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    messagesReplyInput: {
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      padding: '0.75rem',
      fontFamily: 'inherit',
      fontSize: '0.9rem',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT
    },
    messagesReplyActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '0.65rem',
      flexWrap: 'wrap' as const
    },
    messagesReplyButton: {
      border: `1px solid ${BRAND_TEXT}`,
      borderRadius: '0.75rem',
      backgroundColor: BRAND_TEXT,
      color: '#ffffff',
      padding: '0.55rem 1rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    messagesReplyButtonSecondary: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT,
      padding: '0.55rem 1rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    messagesReplyButtonGhost: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      padding: '0.55rem 1rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    messagesEmpty: {
      padding: '1rem',
      borderRadius: '0.6rem',
      border: `1px dashed ${BRAND_BORDER}`,
      color: BRAND_MUTED,
      backgroundColor: BRAND_SURFACE_SOFT,
      display: 'grid',
      gap: '0.75rem'
    },
    messagesClearFilters: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '0.75rem',
      padding: '0.4rem 0.9rem',
      fontWeight: 700,
      cursor: 'pointer',
      justifySelf: 'start'
    },
    messagesModalCard: {
      backgroundColor: BRAND_CARD,
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      boxShadow: '0 24px 40px rgba(18, 63, 67, 0.18)'
    },
    messagesModalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '1rem',
      borderBottom: `1px solid ${BRAND_BORDER}`,
      paddingBottom: '0.8rem',
      marginBottom: '0.9rem'
    },
    messagesModalCloseButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '0.65rem',
      padding: '0.42rem 0.8rem',
      fontWeight: 600,
      cursor: 'pointer'
    },
    searchRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    searchInput: {
      padding: '0.72rem 0.95rem',
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      flex: '1 1 320px',
      minWidth: '220px',
      fontSize: '0.95rem',
      color: BRAND_TEXT,
      backgroundColor: '#fffdf9',
      boxShadow: 'inset 0 1px 2px rgba(18, 63, 67, 0.05)'
    },
    casesFilterPanels: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: '0.9rem'
    },
    casesFilterPanel: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.9rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.9rem',
      display: 'grid',
      gap: '0.75rem'
    },
    casesFilterPanelHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    casesFilterPanelTitle: {
      fontSize: '0.82rem',
      fontWeight: 800,
      color: BRAND_TEXT,
      letterSpacing: '0.08em',
      textTransform: 'uppercase' as const
    },
    casesFilterPanelHint: {
      fontSize: '0.84rem',
      color: BRAND_MUTED,
      lineHeight: 1.4
    },
    caseFilterActionButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '999px',
      padding: '0.48rem 0.9rem',
      fontWeight: 700,
      fontSize: '0.82rem',
      cursor: 'pointer',
      whiteSpace: 'nowrap' as const,
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.05)'
    },
    casesFilterToggleButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '0.75rem',
      padding: '0.52rem 0.9rem',
      fontWeight: 700,
      fontSize: '0.84rem',
      cursor: 'pointer',
      whiteSpace: 'nowrap' as const,
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.05)'
    },
    caseFilterActionButtonDisabled: {
      opacity: 0.45,
      cursor: 'not-allowed'
    },
    casesFilterSummaryBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem',
      padding: '0.65rem 0.85rem',
      borderRadius: '0.8rem',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      flexWrap: 'wrap' as const
    },
    casesFilterSummaryText: {
      fontSize: '0.84rem',
      color: BRAND_MUTED
    },
    casesFilterGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
      gap: '0.75rem'
    },
    casesSearchableFilterGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: '0.75rem'
    },
    filterLabel: {
      display: 'grid',
      gap: '0.35rem'
    },
    filterLabelText: {
      fontSize: '0.8rem',
      fontWeight: 700,
      color: BRAND_MUTED
    },
    caseFilterActionRow: {
      display: 'flex',
      alignItems: 'end'
    },
    filterRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.75rem'
    },
    filterSelect: {
      padding: '0.72rem 0.85rem',
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      backgroundColor: '#fffdf9',
      minWidth: '150px',
      width: '100%',
      color: BRAND_TEXT,
      fontSize: '0.92rem',
      boxShadow: 'inset 0 1px 2px rgba(18, 63, 67, 0.04)'
    },
    searchableFilter: {
      position: 'relative' as const,
      display: 'grid',
      gap: '0.35rem'
    },
    searchableFilterLabel: {
      fontSize: '0.8rem',
      fontWeight: 700,
      color: BRAND_MUTED
    },
    searchableFilterTrigger: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '0.75rem',
      padding: '0.72rem 0.85rem',
      minHeight: '44px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.6rem',
      cursor: 'pointer',
      textAlign: 'left' as const,
      boxShadow: 'inset 0 1px 2px rgba(18, 63, 67, 0.04)'
    },
    searchableFilterTriggerOpen: {
      borderColor: BRAND_ACCENT,
      boxShadow: '0 0 0 2px rgba(217, 154, 51, 0.16)'
    },
    searchableFilterTriggerValue: {
      minWidth: 0,
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap' as const,
      fontSize: '0.92rem'
    },
    searchableFilterTriggerIcon: {
      color: BRAND_MUTED,
      fontSize: '0.72rem'
    },
    searchableFilterPopover: {
      position: 'absolute' as const,
      top: 'calc(100% + 0.35rem)',
      left: 0,
      right: 0,
      zIndex: 50,
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: '#fffdf9',
      boxShadow: '0 18px 32px rgba(18, 63, 67, 0.16)',
      padding: '0.65rem',
      display: 'grid',
      gap: '0.55rem'
    },
    searchableFilterSearchInput: {
      width: '100%',
      padding: '0.65rem 0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.65rem',
      fontSize: '0.9rem',
      color: BRAND_TEXT
    },
    searchableFilterOptions: {
      display: 'grid',
      gap: '0.3rem',
      maxHeight: '260px',
      overflowY: 'auto' as const
    },
    searchableFilterOption: {
      border: '1px solid transparent',
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '0.65rem',
      padding: '0.58rem 0.7rem',
      textAlign: 'left' as const,
      cursor: 'pointer',
      fontSize: '0.9rem'
    },
    searchableFilterOptionActive: {
      borderColor: BRAND_ACCENT,
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT,
      fontWeight: 700
    },
    searchableFilterEmpty: {
      border: `1px dashed ${BRAND_BORDER}`,
      borderRadius: '0.65rem',
      backgroundColor: BRAND_SURFACE,
      color: BRAND_MUTED,
      padding: '0.7rem',
      fontSize: '0.85rem'
    },
    newCaseButton: {
      backgroundColor: BRAND_TEXT,
      color: '#ffffff',
      padding: '0.65rem 1.15rem',
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_TEXT}`,
      cursor: 'pointer',
      fontSize: '0.95rem',
      fontWeight: 700,
      boxShadow: '0 8px 18px rgba(18, 63, 67, 0.18)'
    },
    addCustomerForm: {
      backgroundColor: 'white',
      padding: '1.5rem',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      marginBottom: '1.5rem',
      display: 'grid',
      gap: '1rem'
    },
    formRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '1rem'
    },
    formField: {
      flex: '1 1 220px',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.25rem'
    },
    textAreaField: {
      width: '100%',
      minHeight: '100px',
      padding: '0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.375rem',
      resize: 'vertical' as const,
      fontFamily: 'inherit',
      fontSize: '0.95rem',
      color: '#111827'
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '0.9rem',
      color: '#374151'
    },
    actionRow: {
      display: 'flex',
      gap: '0.75rem'
    },
    main: {
      flex: 1,
      padding: '2rem',
      overflowY: 'auto' as const,
      minWidth: 0,
      minHeight: 0,
      backgroundColor: BRAND_SURFACE
    },
    emptyState: {
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '2rem',
      borderRadius: '0.5rem',
      textAlign: 'center' as const,
      color: BRAND_MUTED,
      border: `1px solid ${BRAND_BORDER}`
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, minmax(170px, 1fr))',
      gap: '1rem',
      minWidth: '920px'
    },
    statsGridWrap: {
      overflowX: 'auto' as const,
      marginBottom: '1rem'
    },
    statsAuxRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '2rem'
    },
    statCard: {
      backgroundColor: '#fffdf9',
      padding: '1.5rem',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(18, 63, 67, 0.08)',
      border: `1px solid ${BRAND_BORDER}`
    },
    statCardInteractive: {
      cursor: 'pointer',
      width: '100%',
      textAlign: 'left' as const,
      border: '2px solid transparent',
      backgroundColor: '#ffffff',
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease'
    },
    statCardActive: {
      borderColor: BRAND_ACCENT,
      boxShadow: '0 0 0 2px rgba(217, 154, 51, 0.18)'
    },
    statNumber: {
      fontSize: '2rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem'
    },
    statLabel: {
      color: BRAND_MUTED,
      fontSize: '0.875rem'
    },
    caseList: {
      backgroundColor: '#fffdf9',
      borderRadius: '0.85rem',
      boxShadow: '0 1px 3px rgba(18, 63, 67, 0.08)',
      border: `1px solid ${BRAND_BORDER}`
    },
    caseListHeaderRow: {
      padding: '1rem 1.2rem',
      borderBottom: `1px solid ${BRAND_BORDER}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.9rem',
      flexWrap: 'wrap' as const
    },
    caseListHeaderBlock: {
      display: 'grid',
      gap: '0.2rem'
    },
    caseListHeader: {
      fontWeight: '600',
      fontSize: '1.125rem',
      color: BRAND_TEXT
    },
    caseListMeta: {
      color: BRAND_MUTED,
      fontSize: '0.86rem'
    },
    casePaginationControls: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.55rem',
      flexWrap: 'wrap' as const
    },
    casePageSizeGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.45rem'
    },
    casePageSizeLabel: {
      color: BRAND_MUTED,
      fontSize: '0.82rem',
      fontWeight: 700
    },
    casePageSizeSelect: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '0.7rem',
      padding: '0.45rem 0.7rem',
      fontWeight: 600,
      fontSize: '0.85rem'
    },
    casePaginationButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: '#fffdf9',
      color: BRAND_TEXT,
      borderRadius: '0.7rem',
      padding: '0.48rem 0.8rem',
      fontWeight: 600,
      cursor: 'pointer'
    },
    casePaginationButtonDisabled: {
      opacity: 0.45,
      cursor: 'not-allowed'
    },
    casePaginationStatus: {
      color: BRAND_MUTED,
      fontSize: '0.84rem',
      fontWeight: 600
    },
    casePaginationFooter: {
      padding: '0.95rem 1.2rem',
      borderTop: `1px solid ${BRAND_BORDER}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.9rem',
      flexWrap: 'wrap' as const
    },
    caseCard: {
      padding: '0.92rem 1.1rem',
      borderBottom: `1px solid ${BRAND_BORDER}`,
      cursor: 'pointer',
      transition: 'background-color 0.2s, box-shadow 0.2s'
    },
    caseCardSelected: {
      backgroundColor: BRAND_SURFACE_SOFT,
      boxShadow: `inset 0 0 0 1px ${BRAND_ACCENT}`
    },
    caseHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      marginBottom: '0.5rem'
    },
    caseCardTriColumnRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      alignItems: 'flex-start',
      gap: '0.8rem 1rem'
    },
    caseCardPrimaryBlock: {
      flex: '1.35 1 280px',
      display: 'grid',
      gap: '0.18rem',
      minWidth: 0
    },
    caseCardSecondaryBlock: {
      flex: '1 1 220px',
      display: 'grid',
      gap: '0.14rem',
      minWidth: 0
    },
    caseCardTertiaryBlock: {
      flex: '0.95 1 220px',
      display: 'grid',
      gap: '0.14rem',
      justifyItems: 'end',
      minWidth: 0
    },
    caseCardTitleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.35rem',
      flexWrap: 'wrap' as const
    },
    caseCardHeadline: {
      fontSize: '0.86rem',
      lineHeight: 1.25,
      fontWeight: 600,
      color: BRAND_TEXT,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    caseCardStatusWrap: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.35rem',
      flexWrap: 'wrap' as const,
      justifyContent: 'flex-end'
    },
    caseCardEntityValue: {
      fontSize: '0.8rem',
      fontWeight: 700,
      color: BRAND_TEXT,
      lineHeight: 1.2,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    caseCardEntityValueMuted: {
      fontSize: '0.76rem',
      color: BRAND_MUTED,
      lineHeight: 1.2,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    caseCardAssigneeMain: {
      fontSize: '0.86rem',
      fontWeight: 800,
      color: BRAND_TEXT,
      lineHeight: 1.2,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    caseCardDateMetaRight: {
      fontSize: '0.68rem',
      color: BRAND_MUTED,
      textAlign: 'right' as const,
      whiteSpace: 'nowrap' as const
    },
    caseCardAttachmentMeta: {
      fontSize: '0.67rem',
      color: BRAND_MUTED,
      textAlign: 'right' as const,
      whiteSpace: 'nowrap' as const
    },
    caseCardInfoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
      gap: '0.32rem 0.75rem',
      marginBottom: '0.38rem'
    },
    caseCardInfoItem: {
      display: 'grid',
      gap: '0.08rem',
      minWidth: 0
    },
    caseCardInfoLabel: {
      fontSize: '0.61rem',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.055em',
      fontWeight: 700,
      color: BRAND_MUTED
    },
    caseCardInfoValue: {
      fontSize: '0.8rem',
      fontWeight: 600,
      color: BRAND_TEXT,
      lineHeight: 1.2,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    caseCardInfoValueMuted: {
      fontSize: '0.74rem',
      color: BRAND_MUTED,
      lineHeight: 1.2
    },
    caseCardMetaRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.55rem',
      flexWrap: 'wrap' as const,
      borderTop: `1px solid ${BRAND_BORDER}`,
      paddingTop: '0.28rem'
    },
    caseCardDateMeta: {
      fontSize: '0.7rem',
      color: BRAND_MUTED
    },
    caseNumber: {
      fontWeight: '800',
      fontSize: '1.12rem',
      lineHeight: 1.2
    },
    caseCardAttachmentMetaLeft: {
      fontSize: '0.67rem',
      color: BRAND_MUTED,
      whiteSpace: 'nowrap' as const,
      marginTop: '0.05rem'
    },
    analysisBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.35rem',
      padding: '0.125rem 0.6rem',
      borderRadius: '9999px',
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.01em'
    },
    analysisBadgeAccepted: {
      backgroundColor: BRAND_SUCCESS_SOFT,
      color: BRAND_SUCCESS_TEXT
    },
    analysisBadgePending: {
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_ACCENT_TEXT
    },
    analysisBadgeIdle: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_MUTED
    },
    analysisMetaRow: {
      fontSize: '0.71rem',
      color: BRAND_MUTED,
      lineHeight: 1.25
    },
    timeline: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.75rem',
      paddingLeft: '0.5rem',
      borderLeft: `3px solid ${BRAND_BORDER}`,
      marginTop: '0.5rem'
    },
    timelineItem: {
      position: 'relative' as const,
      paddingLeft: '1rem'
    },
    timelineBullet: {
      position: 'absolute' as const,
      left: '-0.9rem',
      top: '0.35rem',
      width: '0.6rem',
      height: '0.6rem',
      borderRadius: '9999px',
      backgroundColor: BRAND_ACCENT
    },
    timelineMeta: {
      fontSize: '0.8rem',
      color: BRAND_MUTED,
      marginTop: '0.25rem'
    },
    quoteList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.5rem',
      marginTop: '0.5rem'
    },
    quoteCard: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.5rem',
      padding: '0.75rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '0.75rem'
    },
    quoteMeta: {
      fontSize: '0.8rem',
      color: BRAND_MUTED
    },
    quoteDecisionPill: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: '9999px',
      padding: '0.18rem 0.55rem',
      fontSize: '0.7rem',
      fontWeight: 700,
      letterSpacing: '0.02em',
      marginLeft: '0.45rem'
    },
    quoteDecisionAccepted: {
      backgroundColor: BRAND_SUCCESS_SOFT,
      color: BRAND_SUCCESS_TEXT
    },
    quoteDecisionDenied: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    quoteDecisionAdjust: {
      backgroundColor: '#fef3c7',
      color: '#92400e'
    },
    quoteDecisionPending: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT
    },
    quotePartsPill: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: '9999px',
      padding: '0.16rem 0.5rem',
      fontSize: '0.68rem',
      fontWeight: 700,
      letterSpacing: '0.01em'
    },
    quotePartsSuccess: {
      backgroundColor: '#dcfce7',
      color: '#166534'
    },
    quotePartsInfo: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT
    },
    quotePartsWarning: {
      backgroundColor: '#fef3c7',
      color: '#92400e'
    },
    quotePartsDanger: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    quoteViewButton: {
      padding: '0.35rem 0.8rem',
      borderRadius: '9999px',
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      fontWeight: 600,
      cursor: 'pointer'
    },
    taskList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.5rem',
      marginTop: '0.5rem'
    },
    taskCard: {
      border: '1px solid #e5e7eb',
      borderRadius: '0.375rem',
      padding: '0.75rem',
      backgroundColor: '#f9fafb'
    },
    taskHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 600,
      marginBottom: '0.25rem'
    },
    taskMeta: {
      fontSize: '0.8rem',
      color: '#4b5563'
    },
    keyValueGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '0.5rem 1.5rem',
      marginTop: '0.5rem'
    },
    keyValueItem: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.15rem',
      fontSize: '0.85rem'
    },
    keyLabel: {
      fontWeight: 600,
      color: '#4b5563',
      fontSize: '0.75rem',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.04em'
    },
    keyValue: {
      color: '#111827'
    },
    caseActionPanel: {
      marginTop: '1.25rem',
      borderTop: `1px dashed ${BRAND_BORDER}`,
      paddingTop: '1.25rem',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '1rem'
    },
    caseQuickViewOverlay: {
      position: 'fixed' as const,
      inset: 0,
      zIndex: 950,
      backgroundColor: 'rgba(15, 23, 42, 0.35)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflowY: 'auto' as const,
      padding: '1rem'
    },
    caseQuickViewCard: {
      width: 'min(1220px, 96vw)',
      maxHeight: 'calc(100vh - 2rem)',
      overflowY: 'auto' as const,
      backgroundColor: BRAND_CARD,
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.8rem',
      boxShadow: '0 24px 40px rgba(18, 63, 67, 0.18)',
      padding: '1rem',
      display: 'grid',
      gap: '0.9rem'
    },
    caseQuickViewHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.65rem',
      position: 'sticky' as const,
      top: 0,
      zIndex: 3,
      backgroundColor: BRAND_CARD,
      borderBottom: `1px solid ${BRAND_BORDER}`,
      paddingBottom: '0.45rem'
    },
    caseQuickViewTitleWrap: {
      display: 'grid',
      gap: '0.1rem'
    },
    caseQuickViewTitle: {
      fontSize: '1.55rem',
      fontWeight: 800,
      color: BRAND_TEXT
    },
    caseQuickViewSubTitle: {
      fontSize: '0.9rem',
      color: BRAND_MUTED
    },
    customerContactEditorSubTitle: {
      fontSize: '1.06rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    caseQuickViewSummary: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      fontSize: '0.84rem',
      color: BRAND_MUTED
    },
    caseQuickViewCloseButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '0.65rem',
      padding: '0.42rem 0.8rem',
      fontWeight: 600,
      cursor: 'pointer'
    },
    quickViewUtilityButton: {
      border: `1px solid ${BRAND_ACCENT}`,
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_TEXT,
      borderRadius: '9999px',
      padding: '0.42rem 0.9rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    quickViewPrimaryPillButton: {
      border: `1px solid ${BRAND_TEXT}`,
      backgroundColor: BRAND_TEXT,
      color: '#ffffff',
      borderRadius: '9999px',
      padding: '0.45rem 1rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    quickViewGhostPillButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '9999px',
      padding: '0.45rem 1rem',
      fontWeight: 600,
      cursor: 'pointer'
    },
    quickViewBoxButton: {
      border: `1px solid ${BRAND_BORDER}`,
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      borderRadius: '0.8rem',
      padding: '0.5rem 1rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    quickViewBoxButtonDanger: {
      borderColor: BRAND_DANGER_BORDER,
      backgroundColor: BRAND_DANGER_SOFT,
      color: BRAND_DANGER_TEXT
    },
    quickViewBoxButtonPrimary: {
      borderColor: BRAND_TEXT,
      backgroundColor: BRAND_TEXT,
      color: '#ffffff'
    },
    quickViewBoxButtonSuccess: {
      borderColor: BRAND_SUCCESS_BORDER,
      backgroundColor: BRAND_SUCCESS_SOFT,
      color: BRAND_SUCCESS_TEXT
    },
    quickViewDangerPillButton: {
      border: `1px solid ${BRAND_DANGER_BORDER}`,
      backgroundColor: BRAND_DANGER_SOFT,
      color: BRAND_DANGER_TEXT,
      borderRadius: '9999px',
      padding: '0.33rem 0.8rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    quickViewAddDetailButton: {
      justifySelf: 'start',
      border: `1px dashed ${BRAND_TEXT_SOFT_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      color: BRAND_TEXT,
      borderRadius: '9999px',
      padding: '0.4rem 0.9rem',
      fontWeight: 700,
      cursor: 'pointer'
    },
    caseQuickViewActionPanel: {
      marginTop: 0,
      borderTop: 'none',
      paddingTop: 0
    },
    assignmentHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '1rem',
      flexWrap: 'wrap' as const
    },
    assignmentSummary: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.35rem',
      minWidth: 0
    },
    assignmentTitle: {
      fontSize: '0.95rem',
      fontWeight: 700,
      color: BRAND_TEXT
    },
    assignmentCopy: {
      fontSize: '0.85rem',
      color: BRAND_MUTED,
      lineHeight: 1.45
    },
    assignmentMetaRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      fontSize: '0.8rem',
      color: BRAND_MUTED
    },
    assignmentBadgeStack: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      alignItems: 'center'
    },
    assignmentChip: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.35rem 0.9rem',
      borderRadius: '9999px',
      fontWeight: 600,
      fontSize: '0.75rem'
    },
    assignmentActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.75rem',
      alignItems: 'flex-start'
    },
    assignmentGroup: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.35rem'
    },
    assignmentButton: {
      padding: '0.45rem 1.1rem',
      borderRadius: '9999px',
      border: `1px solid ${BRAND_BORDER}`,
      background: BRAND_CARD,
      color: BRAND_TEXT,
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'background-color 0.2s, color 0.2s, border-color 0.2s'
    },
    assignmentButtonPrimary: {
      background: BRAND_TEXT,
      color: '#ffffff',
      borderColor: BRAND_TEXT
    },
    assignmentButtonActive: {
      color: '#ffffff'
    },
    assignmentButtonGhost: {
      background: BRAND_CARD,
      borderColor: BRAND_BORDER,
      color: BRAND_TEXT
    },
    assignmentButtonCancel: {
      background: BRAND_SURFACE,
      borderColor: BRAND_BORDER,
      color: BRAND_TEXT
    },
    assignmentButtonDisabled: {
      opacity: 0.6,
      cursor: 'not-allowed'
    },
    assignmentVariantRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.45rem'
    },
    assignmentVariantButton: {
      minHeight: '2.85rem',
      minWidth: '12.5rem',
      padding: '0.65rem 1.25rem',
      borderRadius: '0.35rem',
      border: `1px dashed ${BRAND_TEXT_SOFT_BORDER}`,
      background: BRAND_CARD,
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.2,
      textAlign: 'center' as const,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.2s, color 0.2s, border-color 0.2s'
    },
    maintenanceVariantPanel: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.4rem',
      backgroundColor: BRAND_SUCCESS_SOFT,
      borderRadius: '0.75rem',
      padding: '0.9rem',
      marginTop: '0.75rem',
      border: `1px dashed ${BRAND_SUCCESS_BORDER}`
    },
    maintenanceVariantHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    maintenanceVariantHint: {
      fontSize: '0.75rem',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.08em',
      color: BRAND_SUCCESS_TEXT
    },
    maintenanceVariantNote: {
      fontSize: '0.75rem',
      color: BRAND_SUCCESS_TEXT
    },
    installPhaseRow: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.4rem',
      width: '100%'
    },
    installPhasePanel: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.5rem',
      backgroundColor: '#FCF6EA',
      borderRadius: '0.75rem',
      padding: '0.9rem',
      marginTop: '0.75rem',
      border: `1px dashed ${BRAND_ACCENT}`
    },
    installPhaseHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    installPhaseHint: {
      fontSize: '0.75rem',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.08em',
      color: BRAND_ACCENT_TEXT
    },
    installPhaseNote: {
      fontSize: '0.75rem',
      color: BRAND_MUTED
    },
    installPhaseButtons: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.45rem'
    },
    installPhaseButton: {
      minHeight: '2.85rem',
      minWidth: '12.5rem',
      padding: '0.65rem 1.25rem',
      borderRadius: '0.35rem',
      border: `1px dashed ${BRAND_TEXT_SOFT_BORDER}`,
      background: BRAND_CARD,
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.2,
      textAlign: 'center' as const,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    repairWorkflowPanel: {
      marginTop: '0.75rem',
      borderRadius: '0.75rem',
      border: `1px dashed ${BRAND_ACCENT}`,
      backgroundColor: '#FCF6EA',
      padding: '0.9rem',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.45rem'
    },
    repairWorkflowHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    repairWorkflowHint: {
      fontSize: '0.75rem',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.08em',
      color: BRAND_ACCENT_TEXT
    },
    repairWorkflowNote: {
      fontSize: '0.75rem',
      color: BRAND_TEXT,
      fontWeight: 600
    },
    repairWorkflowActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem'
    },
    assignmentError: {
      fontSize: '0.8rem',
      color: BRAND_DANGER_TEXT
    },
    assignmentPlaceholder: {
      fontSize: '0.8rem',
      color: BRAND_MUTED,
      fontStyle: 'italic'
    },
    caseActionSummary: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.35rem',
      color: BRAND_MUTED
    },
    caseActionSummaryTitle: {
      fontSize: '0.85rem',
      fontWeight: 600,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.04em',
      color: BRAND_ACCENT_TEXT
    },
    caseActionSummaryCopy: {
      fontSize: '0.85rem',
      color: BRAND_MUTED
    },
    caseActionButtons: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.75rem'
    },
    caseActionButtonPrimary: {
      backgroundColor: BRAND_TEXT,
      color: '#ffffff',
      border: `1px solid ${BRAND_TEXT}`,
      minHeight: '2.85rem',
      minWidth: '12.5rem',
      padding: '0.65rem 1.25rem',
      borderRadius: '0.35rem',
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
    caseActionButtonSecondary: {
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT,
      border: `1px solid ${BRAND_BORDER}`,
      minHeight: '2.85rem',
      minWidth: '12.5rem',
      padding: '0.65rem 1.25rem',
      borderRadius: '0.35rem',
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
    caseActionButtonGhost: {
      backgroundColor: BRAND_CARD,
      border: `1px solid ${BRAND_BORDER}`,
      color: BRAND_TEXT,
      padding: '0.5rem 1.25rem'
    },
    caseStatus: {
      padding: '0.25rem 0.75rem',
      borderRadius: '9999px',
      fontSize: '0.75rem',
      fontWeight: '500'
    },
    statusNew: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT
    },
    statusInProgress: {
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_ACCENT_TEXT
    },
    statusOnHold: {
      backgroundColor: '#F1E2D4',
      color: '#8C5A2B'
    },
    statusResolved: {
      backgroundColor: BRAND_SUCCESS_SOFT,
      color: BRAND_SUCCESS_TEXT
    },
    statusClosed: {
      backgroundColor: '#FFF3D8',
      color: '#8A611E',
      border: `1px solid ${BRAND_ACCENT}`,
      fontWeight: 800
    },
    caseDetails: {
      fontSize: '0.875rem',
      color: BRAND_MUTED,
      marginBottom: '0.5rem'
    },
    priority: {
      padding: '0.25rem 0.5rem',
      borderRadius: '0.25rem',
      fontSize: '0.75rem',
      fontWeight: '500',
      marginLeft: '0.5rem'
    },
    priorityCritical: {
      backgroundColor: '#b91c1c',
      color: '#ffffff'
    },
    priorityHigh: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    priorityMedium: {
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_ACCENT_TEXT
    },
    priorityLow: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT
    },
    caseFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '0.75rem',
      color: BRAND_MUTED
    },
    modal: {
      position: 'fixed' as const,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      padding: '2rem',
      maxWidth: '600px',
      width: '90%',
      maxHeight: '90vh',
      overflow: 'auto'
    },
    modalContentWide: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      padding: '2rem',
      maxWidth: '850px',
      width: '95%',
      maxHeight: '90vh',
      overflow: 'auto'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem'
    },
    modalTitle: {
      fontSize: '1.5rem',
      fontWeight: '600'
    },
    closeButton: {
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#6b7280'
    },
    inlineLinkButton: {
      background: 'none',
      border: 'none',
      color: '#2563eb',
      padding: 0,
      fontSize: '0.9rem',
      fontWeight: 600,
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    modalSection: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '1rem'
    },
    modalList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.75rem'
    },
    modalListItem: {
      border: '1px solid #e5e7eb',
      borderRadius: '0.5rem',
      padding: '0.75rem 1rem',
      backgroundColor: '#f9fafb'
    },
    modalItemTitle: {
      fontWeight: 600,
      fontSize: '1rem',
      marginBottom: '0.25rem',
      color: '#111827'
    },
    modalItemMeta: {
      fontSize: '0.85rem',
      color: '#4b5563',
      marginBottom: '0.25rem'
    },
    modalFooter: {
      marginTop: '1.5rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '0.75rem',
      flexWrap: 'wrap' as const
    },
    modalLink: {
      color: '#2563eb',
      cursor: 'pointer',
      textDecoration: 'underline',
      fontSize: '0.9rem',
      fontWeight: 500
    },
    infoSection: {
      marginBottom: '1.5rem'
    },
    label: {
      fontWeight: '600',
      marginBottom: '0.25rem',
      display: 'block'
    },
    value: {
      color: '#374151'
    },
    mediaGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: '0.75rem',
      marginTop: '0.75rem'
    },
    mediaCard: {
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      backgroundColor: '#ffffff',
      padding: '0.5rem',
      display: 'grid',
      gap: '0.5rem'
    },
    mediaPreview: {
      width: '100%',
      borderRadius: '0.5rem',
      backgroundColor: '#f3f4f6'
    },
    mediaMeta: {
      fontSize: '0.75rem',
      color: '#6b7280'
    },
    mediaFileName: {
      fontSize: '0.85rem',
      fontWeight: 600,
      color: '#111827'
    },
    mediaLink: {
      color: '#2563eb',
      textDecoration: 'none',
      fontSize: '0.85rem',
      fontWeight: 600
    },
    statusSelect: {
      width: '100%',
      padding: '0.5rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.375rem',
      marginBottom: '1rem'
    },
    actionButton: {
      backgroundColor: '#3b82f6',
      color: 'white',
      padding: '0.5rem 1.5rem',
      borderRadius: '0.375rem',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      width: '100%'
    },
    customerList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '1rem'
    },
    customerCard: {
      backgroundColor: 'white',
      padding: '1.5rem',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    customerWorkspaceLayout: {
      display: 'grid',
      gridTemplateColumns: 'minmax(340px, 0.95fr) minmax(420px, 1.35fr)',
      gap: '1rem',
      alignItems: 'start'
    },
    customerQueuePanel: {
      backgroundColor: BRAND_CARD,
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: '0 10px 24px rgba(18, 63, 67, 0.05)',
      padding: '1.1rem',
      display: 'grid',
      gap: '1rem'
    },
    customerQueueList: {
      display: 'grid',
      gap: '0.75rem'
    },
    customerQueueButton: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_CARD,
      padding: '0.95rem 1rem',
      display: 'grid',
      gap: '0.65rem',
      textAlign: 'left' as const,
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.04)'
    },
    customerQueueButtonSelected: {
      borderColor: BRAND_BORDER,
      boxShadow: `inset 0 0 0 1px ${BRAND_ACCENT}`,
      backgroundColor: BRAND_SURFACE_SOFT
    },
    customerQueueTop: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '0.75rem'
    },
    customerQueueTitleWrap: {
      display: 'grid',
      gap: '0.2rem',
      minWidth: 0,
      flex: 1
    },
    customerQueueNameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.45rem',
      flexWrap: 'wrap' as const
    },
    customerQueueName: {
      fontSize: '1rem',
      fontWeight: 700,
      color: '#0f172a'
    },
    customerQueueLocation: {
      fontSize: '0.88rem',
      color: '#475569',
      lineHeight: 1.35
    },
    customerQueueCreated: {
      fontSize: '0.75rem',
      color: '#64748b',
      whiteSpace: 'nowrap' as const
    },
    customerQueueCounts: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.45rem'
    },
    customerCountChip: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: '999px',
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT,
      border: `1px solid ${BRAND_TEXT_SOFT_BORDER}`,
      padding: '0.2rem 0.6rem',
      fontSize: '0.76rem',
      fontWeight: 700
    },
    customerCardRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.85rem',
      flexWrap: 'wrap' as const
    },
    customerCardAvatarWrap: {
      flex: '0 0 auto'
    },
    customerCardAvatar: {
      width: '3rem',
      height: '3rem',
      borderRadius: '0.95rem',
      background: `linear-gradient(135deg, ${BRAND_ACCENT_SOFT} 0%, ${BRAND_SURFACE_SOFT} 100%)`,
      border: `1px solid ${BRAND_BORDER}`,
      color: BRAND_TEXT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 800,
      fontSize: '0.95rem'
    },
    customerCardAvatarImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      borderRadius: '0.95rem',
      display: 'block'
    },
    customerCardPrimaryBlock: {
      flex: '1.35 1 280px',
      minWidth: 0,
      display: 'grid',
      gap: '0.2rem'
    },
    customerCardSecondaryBlock: {
      flex: '1 1 260px',
      minWidth: 0,
      display: 'grid',
      gap: '0.3rem'
    },
    customerCardTertiaryBlock: {
      flex: '0.6 1 150px',
      minWidth: 0,
      display: 'grid',
      justifyItems: 'end',
      gap: '0.2rem'
    },
    customerCardTitle: {
      fontSize: '1rem',
      fontWeight: 800,
      color: '#0f172a',
      lineHeight: 1.2
    },
    customerCardSubTitle: {
      fontSize: '0.82rem',
      color: '#334155',
      lineHeight: 1.35,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    customerCardCounts: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.4rem'
    },
    customerCardViewHint: {
      fontSize: '0.76rem',
      color: '#64748b',
      fontWeight: 700,
      whiteSpace: 'nowrap' as const
    },
    customerQuickViewHero: {
      display: 'grid',
      gridTemplateColumns: 'minmax(280px, 1.1fr) minmax(320px, 1fr)',
      gap: '1rem',
      alignItems: 'stretch'
    },
    customerQuickViewIdentity: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_CARD,
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.04)',
      padding: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.9rem'
    },
    customerQuickViewAvatar: {
      width: '7.75rem',
      height: '7.75rem',
      borderRadius: '1.1rem',
      background: `linear-gradient(135deg, ${BRAND_ACCENT_SOFT} 0%, ${BRAND_SURFACE} 100%)`,
      border: `1px solid ${BRAND_BORDER}`,
      color: BRAND_TEXT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 800,
      fontSize: '1.55rem',
      flex: '0 0 auto'
    },
    customerQuickViewAvatarImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      borderRadius: '1.1rem',
      display: 'block'
    },
    customerQuickViewIdentityCopy: {
      display: 'grid',
      gap: '0.25rem',
      minWidth: 0,
      alignContent: 'center'
    },
    customerQuickViewIdentityTitle: {
      fontSize: '1.15rem',
      fontWeight: 800,
      color: '#0f172a'
    },
    customerQuickViewIdentityMeta: {
      fontSize: '0.9rem',
      color: '#475569',
      lineHeight: 1.45
    },
    customerQuickViewCountGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(140px, 1fr))',
      gap: '0.75rem'
    },
    customerQuickViewCountCard: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.9rem 1rem',
      display: 'grid',
      gap: '0.15rem'
    },
    customerQuickViewCountNumber: {
      fontSize: '1.55rem',
      fontWeight: 800,
      color: '#0f172a'
    },
    customerQuickViewCountLabel: {
      fontSize: '0.82rem',
      fontWeight: 700,
      color: '#64748b'
    },
    customerQuickViewActionGrid: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.55rem'
    },
    customerQuickViewStatusGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
      gap: '0.75rem'
    },
    customerQuickViewMiniList: {
      display: 'grid',
      gap: '0.65rem'
    },
    customerQuickViewMiniListItem: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.85rem 0.95rem',
      display: 'grid',
      gap: '0.15rem'
    },
    customerQuickViewMiniListTitle: {
      fontSize: '0.92rem',
      fontWeight: 700,
      color: '#0f172a'
    },
    customerQuickViewMiniListMeta: {
      fontSize: '0.8rem',
      color: '#64748b'
    },
    customerPrimaryContactCard: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.9rem',
      background: `linear-gradient(180deg, ${BRAND_SURFACE_SOFT} 0%, ${BRAND_CARD} 100%)`,
      padding: '1rem',
      display: 'grid',
      gap: '0.9rem'
    },
    customerPrimaryContactHeader: {
      display: 'grid',
      gridTemplateColumns: 'minmax(220px, 1.15fr) repeat(3, minmax(150px, 1fr))',
      gap: '1rem',
      alignItems: 'end'
    },
    customerPrimaryContactCopy: {
      display: 'grid',
      gap: '0.15rem',
      minWidth: 0
    },
    customerPrimaryContactEyebrow: {
      fontSize: '0.72rem',
      fontWeight: 800,
      color: BRAND_ACCENT_TEXT,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.05em'
    },
    customerPrimaryContactName: {
      fontSize: '1.08rem',
      fontWeight: 800,
      color: '#0f172a',
      overflowWrap: 'anywhere' as const
    },
    customerPrimaryContactRole: {
      fontSize: '0.86rem',
      color: '#475569',
      overflowWrap: 'anywhere' as const
    },
    customerPrimaryContactMetaItem: {
      display: 'grid',
      gap: '0.18rem',
      minWidth: 0
    },
    customerPrimaryContactMetaLabel: {
      fontSize: '0.72rem',
      fontWeight: 800,
      color: '#64748b',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.05em'
    },
    customerPrimaryContactMetaValue: {
      fontSize: '0.92rem',
      color: '#0f172a',
      lineHeight: 1.45,
      overflowWrap: 'anywhere' as const,
      wordBreak: 'break-word' as const
    },
    customerContactsModalList: {
      display: 'grid',
      gap: '0.85rem'
    },
    customerContactPopupSingleRow: {
      gridTemplateColumns: 'minmax(220px, 1.1fr) minmax(210px, 1fr) minmax(120px, 0.6fr) minmax(250px, 1.05fr) 128px',
      alignItems: 'center',
      gap: '1rem'
    },
    customerLocationPopupSingleRow: {
      gridTemplateColumns: 'minmax(260px, 1fr) 280px',
      alignItems: 'center',
      gap: '1rem'
    },
    customerContactPopupHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '1rem',
      flexWrap: 'wrap' as const
    },
    customerContactPopupActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.55rem',
      flexWrap: 'wrap' as const,
      justifyContent: 'flex-end',
      minWidth: '210px'
    },
    customerContactHierarchyActions: {
      display: 'grid',
      gap: '0.4rem',
      justifyItems: 'end',
      alignContent: 'center',
      minWidth: 0
    },
    customerContactPopupMetaGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
      gap: '0.7rem 1rem'
    },
    customerDeviceModelGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(135px, 1fr))',
      gap: '0.75rem'
    },
    customerDeviceModelButton: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_CARD,
      padding: '0.8rem 0.85rem',
      minHeight: 'unset',
      display: 'block',
      textAlign: 'left' as const,
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(18, 63, 67, 0.04)'
    },
    customerDeviceModelTopRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem'
    },
    customerDeviceModelSummary: {
      display: 'grid',
      gap: '0.15rem',
      minWidth: 0,
      flex: 1
    },
    customerDeviceModelCount: {
      fontSize: '1.45rem',
      fontWeight: 800,
      lineHeight: 1,
      color: '#0f172a'
    },
    customerDeviceModelThumb: {
      width: '2.9rem',
      height: '2.9rem',
      borderRadius: '0.75rem',
      backgroundColor: '#f3f4f6',
      border: '1px solid #e5e7eb',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      flexShrink: 0
    },
    customerDeviceModelThumbImage: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain' as const
    },
    customerDeviceModelThumbFallback: {
      fontSize: '0.72rem',
      fontWeight: 700,
      color: '#94a3b8'
    },
    customerDeviceModelLabel: {
      fontSize: '0.86rem',
      fontWeight: 700,
      color: '#64748b',
      lineHeight: 1.2
    },
    customerWorkspacePanel: {
      backgroundColor: BRAND_CARD,
      borderRadius: '0.75rem',
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: '0 10px 24px rgba(18, 63, 67, 0.05)',
      padding: '1.1rem',
      display: 'grid',
      gap: '1rem'
    },
    customerWorkspaceHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '1rem',
      flexWrap: 'wrap' as const
    },
    customerWorkspaceTitleWrap: {
      display: 'grid',
      gap: '0.25rem',
      minWidth: 0
    },
    customerWorkspaceTitle: {
      fontSize: '1.2rem',
      fontWeight: 800,
      color: '#0f172a'
    },
    customerWorkspaceMeta: {
      fontSize: '0.92rem',
      color: '#334155',
      lineHeight: 1.4
    },
    customerWorkspaceSubmeta: {
      fontSize: '0.8rem',
      color: '#64748b'
    },
    customerWorkspaceActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem'
    },
    customerWorkspaceLoading: {
      borderRadius: '0.65rem',
      border: `1px solid ${BRAND_TEXT_SOFT_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      color: BRAND_TEXT,
      padding: '0.8rem 0.95rem',
      fontSize: '0.86rem',
      fontWeight: 600
    },
    customerWorkspaceError: {
      borderRadius: '0.65rem',
      border: '1px solid #fecaca',
      backgroundColor: '#fef2f2',
      color: '#b91c1c',
      padding: '0.8rem 0.95rem',
      fontSize: '0.86rem',
      fontWeight: 600
    },
    customerWorkspaceStats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '0.75rem'
    },
    customerWorkspaceActionGrid: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.55rem'
    },
    customerSummaryRow: {
      marginTop: '0.5rem',
      color: '#4b5563',
      fontSize: '0.9rem',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      flexWrap: 'wrap' as const
    },
    customerCompactRow: {
      marginTop: '0.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.85rem',
      flexWrap: 'wrap' as const
    },
    customerCompactMeta: {
      color: '#4b5563',
      fontSize: '0.9rem',
      fontWeight: 500
    },
    customerNotes: {
      marginTop: '0.75rem',
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '0.5rem',
      padding: '0.75rem',
      color: '#374151',
      fontSize: '0.9rem',
      whiteSpace: 'pre-wrap' as const,
      lineHeight: 1.4
    },
    customerNotesLauncher: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.75rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      padding: '0.85rem 1rem'
    },
    customerNotesLauncherCopy: {
      fontSize: '0.88rem',
      color: BRAND_MUTED
    },
    customerNotesModalCard: {
      width: 'min(900px, 94vw)',
      maxHeight: 'min(78vh, 900px)'
    },
    customerEditModalCard: {
      width: 'min(860px, 94vw)',
      maxHeight: 'min(78vh, 900px)'
    },
    customerCreateModalCard: {
      width: 'min(1160px, 96vw)',
      maxHeight: 'min(82vh, 960px)'
    },
    customerContactEditorModalCard: {
      width: 'min(920px, 95vw)',
      maxHeight: 'min(82vh, 920px)'
    },
    customerLocationEditorModalCard: {
      width: 'min(920px, 95vw)',
      maxHeight: 'min(82vh, 920px)'
    },
    customerContactsModalCard: {
      width: 'min(1120px, 96vw)',
      maxHeight: 'min(82vh, 920px)'
    },
    customerDevicesModalCard: {
      width: 'min(1160px, 96vw)',
      maxHeight: 'min(82vh, 920px)'
    },
    customerAddDeviceModalCard: {
      width: 'min(920px, 95vw)',
      maxHeight: 'min(78vh, 860px)'
    },
    customerNotesModalTextarea: {
      width: '100%',
      height: '56vh',
      maxHeight: '56vh',
      resize: 'none' as const,
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.85rem',
      backgroundColor: BRAND_SURFACE_SOFT,
      color: BRAND_TEXT,
      fontSize: '0.95rem',
      lineHeight: 1.55,
      padding: '1rem',
      boxSizing: 'border-box' as const,
      overflowY: 'auto' as const
    },
    customerNotesModalTextareaReadOnly: {
      cursor: 'default'
    },
    customerNotesModalTextareaEditable: {
      outline: 'none'
    },
    customerImageUploadZone: {
      border: `1px dashed ${BRAND_TEXT_SOFT_BORDER}`,
      backgroundColor: BRAND_SURFACE_SOFT,
      borderRadius: '0.85rem',
      padding: '1rem',
      display: 'grid',
      gap: '0.55rem'
    },
    customerImageUploadTitle: {
      fontSize: '0.92rem',
      fontWeight: 700,
      color: '#0f172a'
    },
    customerImageUploadMeta: {
      fontSize: '0.84rem',
      color: '#475569'
    },
    customerImageUploadHint: {
      fontSize: '0.78rem',
      color: '#64748b'
    },
    customerContactEditorForm: {
      display: 'grid',
      gap: '1rem'
    },
    customerDeviceEditorForm: {
      display: 'grid',
      gap: '1rem'
    },
    customerContactEditorCustomerName: {
      fontSize: '1rem',
      fontWeight: 700,
      color: '#0f172a'
    },
    customerContactEditorActions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.8rem',
      flexWrap: 'wrap' as const
    },
    customerContactEditorActionGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.6rem',
      flexWrap: 'wrap' as const
    },
    customerDevicesModalList: {
      display: 'grid',
      gap: '0.85rem'
    },
    customerDevicePopupSingleRow: {
      gridTemplateColumns: 'minmax(220px, 1.1fr) repeat(3, minmax(120px, 1fr))',
      alignItems: 'center',
      gap: '1rem'
    },
    customerNotesLabel: {
      display: 'block',
      fontWeight: 600,
      color: '#1f2937',
      marginBottom: '0.25rem'
    },
    customerQuickActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      marginTop: '0.75rem'
    },
    customerDetails: {
      marginTop: '1rem',
      display: 'grid',
      gap: '1.25rem'
    },
    inlineForm: {
      backgroundColor: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: '0.5rem',
      padding: '1rem',
      display: 'grid',
      gap: '0.75rem'
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.75rem'
    },
    sectionTitle: {
      fontSize: '1rem',
      fontWeight: 600
    },
    emptySubtle: {
      color: '#6b7280',
      fontSize: '0.9rem'
    },
    errorText: {
      color: '#b91c1c',
      fontSize: '0.86rem',
      fontWeight: 600
    },
    contactList: {
      display: 'grid',
      gap: '0.75rem'
    },
    contactCard: {
      backgroundColor: '#f9fafb',
      borderRadius: '0.5rem',
      border: '1px solid #e5e7eb',
      padding: '0.75rem 1rem',
      display: 'grid',
      gap: '0.5rem'
    },
    contactSummaryButton: {
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: 'left' as const,
      padding: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem'
    },
    contactSummaryLeft: {
      minWidth: 0
    },
    contactExpandLabel: {
      color: BRAND_ACCENT_TEXT,
      fontSize: '0.8rem',
      fontWeight: 600,
      whiteSpace: 'nowrap' as const
    },
    contactHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '0.75rem'
    },
    contactNameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontWeight: 600
    },
    contactMeta: {
      color: '#4b5563',
      fontSize: '0.85rem'
    },
    contactMetaRow: {
      color: '#4b5563',
      fontSize: '0.85rem'
    },
    contactActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      justifyContent: 'flex-start'
    },
    badgePrimary: {
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_ACCENT_TEXT
    },
    badgePortalActive: {
      backgroundColor: '#dcfce7',
      color: '#166534'
    },
    badgePortalPending: {
      backgroundColor: BRAND_SURFACE,
      color: BRAND_MUTED
    },
    badgeLocation: {
      backgroundColor: BRAND_TEXT_SOFT,
      color: BRAND_TEXT
    },
    actionPill: {
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '999px',
      padding: '0.28rem 0.72rem',
      fontSize: '0.78rem',
      fontWeight: 600,
      cursor: 'pointer',
      backgroundColor: BRAND_CARD,
      color: BRAND_TEXT
    },
    actionPillNeutral: {
      borderColor: BRAND_BORDER,
      backgroundColor: BRAND_SURFACE_SOFT,
      color: BRAND_TEXT
    },
    actionPillPrimary: {
      borderColor: BRAND_TEXT,
      backgroundColor: BRAND_TEXT,
      color: '#ffffff'
    },
    actionPillDanger: {
      borderColor: '#fecaca',
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    actionPillSuccess: {
      borderColor: '#bbf7d0',
      backgroundColor: '#dcfce7',
      color: '#166534'
    },
    actionPillWarning: {
      borderColor: BRAND_ACCENT,
      backgroundColor: BRAND_ACCENT_SOFT,
      color: BRAND_ACCENT_TEXT
    },
    detailSection: {
      backgroundColor: '#ffffff',
      borderRadius: '0.5rem',
      border: '1px solid #e5e7eb',
      padding: '1rem',
      display: 'grid',
      gap: '0.75rem'
    },
    locationStack: {
      display: 'grid',
      gap: '0.75rem'
    },
    locationCard: {
      backgroundColor: '#f9fafb',
      borderRadius: '0.5rem',
      border: '1px solid #e5e7eb',
      padding: '0.75rem 1rem',
      display: 'grid',
      gap: '0.75rem'
    },
    locationHeader: {
      display: 'flex',
      gap: '0.75rem'
    },
    locationHeaderBody: {
      display: 'grid',
      gap: '0.45rem',
      width: '100%'
    },
    locationNameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontWeight: 600
    },
    locationMeta: {
      fontSize: '0.85rem',
      color: '#4b5563'
    },
    locationCounters: {
      display: 'flex',
      gap: '1rem',
      fontSize: '0.8rem',
      color: '#4b5563'
    },
    locationActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.5rem',
      justifyContent: 'flex-start'
    },
    portalInviteModal: {
      width: 'min(760px, 92vw)',
      maxHeight: '85vh',
      overflowY: 'auto' as const,
      backgroundColor: '#fff',
      borderRadius: '0.75rem',
      border: '1px solid #dbe3ef',
      boxShadow: '0 24px 40px rgba(15, 23, 42, 0.2)'
    },
    portalInviteBody: {
      padding: '1rem',
      display: 'grid',
      gap: '0.7rem'
    },
    portalInviteRow: {
      display: 'grid',
      gap: '0.35rem'
    },
    portalInviteLabel: {
      fontSize: '0.78rem',
      color: '#64748b',
      fontWeight: 600
    },
    portalInviteValueWrap: {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      flexWrap: 'wrap' as const
    },
    portalInviteCode: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '0.35rem',
      padding: '0.18rem 0.45rem',
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      fontSize: '0.8rem'
    },
    portalInviteCodeLong: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '0.35rem',
      padding: '0.3rem 0.45rem',
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      fontSize: '0.76rem',
      wordBreak: 'break-all' as const
    },
    portalInviteHint: {
      marginTop: '0.3rem',
      padding: '0.6rem 0.75rem',
      borderRadius: '0.45rem',
      border: '1px solid #dbeafe',
      backgroundColor: '#eff6ff',
      color: '#1e3a8a',
      fontSize: '0.82rem'
    },
    deviceTable: {
      border: '1px solid #e5e7eb',
      borderRadius: '0.5rem',
      overflow: 'hidden'
    },
    deviceRow: {
      display: 'grid',
      gridTemplateColumns: '1.5fr 1.2fr 1.6fr 2.2fr',
      alignItems: 'start',
      borderBottom: '1px solid #e5e7eb'
    },
    deviceHeaderRow: {
      backgroundColor: '#f3f4f6',
      fontWeight: 600
    },
    deviceCell: {
      padding: '0.5rem 0.75rem',
      fontSize: '0.85rem',
      color: '#1f2937'
    },
    deviceActions: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '0.4rem',
      alignItems: 'center'
    },
    deviceWarningCard: {
      marginTop: '0.45rem',
      borderRadius: '0.45rem',
      border: '1px solid #fde68a',
      backgroundColor: '#fffbeb',
      padding: '0.45rem 0.55rem',
      display: 'grid',
      gap: '0.35rem'
    },
    deviceWarningText: {
      fontSize: '0.78rem',
      color: '#92400e'
    },
    deviceWarningActions: {
      display: 'flex',
      gap: '0.4rem',
      flexWrap: 'wrap' as const
    },
    deviceSelect: {
      width: '100%',
      padding: '0.4rem 0.5rem',
      borderRadius: '0.375rem',
      border: '1px solid #d1d5db'
    },
    customerName: {
      fontSize: '1.125rem',
      fontWeight: '600',
      marginBottom: '0.5rem'
    },
    customerInfo: {
      fontSize: '0.875rem',
      color: '#6b7280',
      marginBottom: '0.25rem'
    },
    customerCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '1rem'
    },
    customerNameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontWeight: '600',
      fontSize: '1.1rem'
    },
    customerMeta: {
      fontSize: '0.85rem',
      color: '#6b7280',
      marginTop: '0.25rem'
    },
    statusBadge: {
      backgroundColor: '#dcfce7',
      color: '#166534',
      borderRadius: '999px',
      padding: '0.1rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      lineHeight: 1.2
    },
    statusBadgeInactive: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    metaRow: {
      marginTop: '0.4rem',
      color: '#4b5563',
      fontSize: '0.9rem'
    },
    actionButtons: {
      display: 'flex',
      gap: '0.5rem'
    },
    warningBox: {
      backgroundColor: '#fef3c7',
      border: '1px solid #fbbf24',
      borderRadius: '0.375rem',
      padding: '1rem',
      marginBottom: '1rem'
    },
    warningTitle: {
      fontWeight: '600',
      color: '#92400e',
      marginBottom: '0.5rem'
    },
    warningText: {
      fontSize: '0.875rem',
      color: '#92400e'
    },
    verificationButtons: {
      display: 'flex',
      gap: '0.5rem',
      marginTop: '1rem'
    },
    approveButton: {
      backgroundColor: '#10b981',
      color: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      border: 'none',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    editButton: {
      backgroundColor: '#f59e0b',
      color: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      border: 'none',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    rejectButton: {
      backgroundColor: '#ef4444',
      color: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      border: 'none',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    modelVerificationBadge: {
      backgroundColor: '#fef3c7',
      color: '#92400e',
      padding: '0.25rem 0.5rem',
      borderRadius: '0.25rem',
      fontSize: '0.75rem',
      fontWeight: '500',
      marginLeft: '0.5rem'
    },
    inputField: {
      width: '100%',
      padding: '0.5rem',
      border: `1px solid ${BRAND_BORDER}`,
      borderRadius: '0.375rem',
      marginBottom: '0.5rem',
      color: BRAND_TEXT,
      backgroundColor: '#fffdf9'
    },
    button: {
      padding: '0.5rem 1rem',
      border: 'none',
      borderRadius: '0.375rem',
      fontSize: '1rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    primaryButton: {
      backgroundColor: BRAND_TEXT,
      color: 'white'
    },
    secondaryButton: {
      backgroundColor: BRAND_SURFACE,
      color: BRAND_TEXT,
      border: `1px solid ${BRAND_BORDER}`
    }
  };

